/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */

import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import BadgeIcon from '@mui/icons-material/Badge';
import EditIcon from '@mui/icons-material/Edit';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import NoteAdd from '@mui/icons-material/NoteAdd';
import NoteIcon from '@mui/icons-material/NoteAlt';
import PaidIcon from '@mui/icons-material/Paid';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { UserService } from '@pingum/api-services';
import Moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  Info,
  InfoOutlined,
  Topic,
  WorkspacePremium,
} from '@mui/icons-material';
import {
  IconButton,
  OutlinedInput,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import HorseDueDatesComponent from '../../../../../components/HorseDueDates';
import NoteItem from '../../../../../components/NoteItem';
import QuestriCard from '../../../../../components/QuestriCard';
import { getHorseNoteHighlights } from '../../../../../redux/horse/actions';
import { UPDATE_HIGHLIGHTS_LIST } from '../../../../../redux/horse/types';
import HorseService from '../../../../../services/HorseService';
import {
  isUserAdmin,
  isUserOwner,
} from '../../../../../utils/tenantAuthenticationHelper';
import HorseActivityTimeline from './components/HorseActivityTimeline';

const getIconForNoteType = (type) => {
  // Note, Medical, FeedChange, LocationChange, ProfileChange, Competition,
  if (type === 'ProfileChange') return <AssignmentIndIcon />;
  if (type === 'FeedChange') return <RestaurantIcon />;
  if (type === 'LocationChange') return <LocationOnIcon />;
  if (type === 'Billing') return <PaidIcon />;
  if (type === 'Medical') return <MedicalServicesIcon />;
  if (type === 'Competition') return <WorkspacePremium />;
  return <NoteIcon />;
};

export const calculateHorseAge = (dob) => {
  // Calculate the difference in milliseconds between the current date and the provided date of birth
  const diffMs = Date.now() - new Date(dob || 0).getTime();
  // Create a new Date object representing the difference in milliseconds and store it in the variable age_dt (age Date object)
  const ageDt = new Date(diffMs);

  // Calculate the absolute value of the difference in years between the age Date object and the year 1970 (UNIX epoch)
  return Math.abs(ageDt.getUTCFullYear() - 1970);
}

const hasProfileFieldValue = (value) => {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }
  return true;
};

const HighlightsCardsComponent = ({
  id,
  onNotesNavigate,
  openAddEditNoteModal,
  openAddEditBillableModal,
  handleEditProfile,
  condensed,
}) => {
  const dispatch = useDispatch();

  const [openNoteHighlightMenu, setOpenNoteHighlightMenu] = React.useState(null);
  const [noteHighlightAnchorEl, setNoteHighlightAnchorEl] = React.useState(null);

  // Redux state
  const horse = useSelector((state) => state.horse.horse);
  const horseNoteHighlights = useSelector((state) => state.horse.horseNoteHighlights);
  const isFetchingHorseNoteHighlights = useSelector((state) => state.horse.isFetchingHorseNoteHighlights);
  const currentHorseLodging = useSelector((state) => state.horse.currentHorseLodging);
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const user = useSelector((state) => state.user.user);

  const roles = UserService.getUserRolesForTenant(
    user,
    selectedBarn.tenant,
  );
  // eslint-disable-next-line no-unused-vars
  const isAdmin = isUserAdmin(roles) || isUserOwner(roles);

  React.useEffect(() => {
    dispatch(getHorseNoteHighlights(id));
  }, [id]);

  const handleEditClick = (noteToEdit) => {
    openAddEditNoteModal(noteToEdit, null, () => { })
  };

  const handleChangeOrder = (highlightNote, newOrder) => {
    const sortedList = horseNoteHighlights.sort((a, b) => a.highlightOrder - b.highlightOrder).map((n, index) => ({
      ...n,
      highlightOrder: (index + 1),
    }));
    const indexOfCurrentNote = sortedList.findIndex((n) => n.id === highlightNote.id);
    const indexOfReplacementNote = sortedList.findIndex((n) => n.highlightOrder === newOrder);

    if (indexOfCurrentNote >= 0 && indexOfReplacementNote >= 0 && indexOfCurrentNote < indexOfReplacementNote) {
      // need to push values up
      for (let i = (indexOfCurrentNote + 1); i <= indexOfReplacementNote; i += 1) {
        HorseService.updateHorseNote(id, sortedList[i].id, { horseHighlight: i });
        sortedList[i].highlightOrder = i;
      }
      // last update the one we need
      HorseService.updateHorseNote(id, highlightNote.id, { horseHighlight: newOrder });
    } else if (indexOfCurrentNote >= 0 && indexOfReplacementNote >= 0 && indexOfCurrentNote > indexOfReplacementNote) {
      // need to push values down
      for (let i = indexOfReplacementNote; i < indexOfCurrentNote; i += 1) {
        HorseService.updateHorseNote(id, sortedList[i].id, { horseHighlight: i + 2 });
        sortedList[i].highlightOrder = i + 2;
      }
      // last update the one we need
      HorseService.updateHorseNote(id, highlightNote.id, { horseHighlight: newOrder });
    }

    sortedList[indexOfCurrentNote].highlightOrder = newOrder;
    // Then dispatch new list to update redux
    dispatch({
      type: UPDATE_HIGHLIGHTS_LIST,
      horseNoteHighlights: sortedList,
    })
  }

  const FieldCard = ({
    label,
    icon,
    value,
    tooltip,
  }) => (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 2,
        height: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: '2', // Truncate after 2 lines
        WebkitBoxOrient: 'vertical',
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase' }}>
        {label}
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        {icon}
        <Tooltip title={tooltip || value || 'No Value'}>
          <Typography variant="body1">{value || '-'}</Typography>
        </Tooltip>
      </Stack>
    </Paper>
  );

  const profileFields = React.useMemo(() => {
    if (!horse) { return []; }
    const fields = [
      ...(horse.usefId
        ? [{
          key: 'usef',
          label: 'USEF ID',
          icon: <BadgeIcon fontSize="small" color="primary" />,
          value: horse.usefId,
        }]
        : []),
      ...Object.entries(horse.referenceNumbers || {}).map(([key, val]) => ({
        key: `ref-${key}`,
        label: key,
        icon: <BadgeIcon fontSize="small" color="primary" />,
        value: val,
      })),
      {
        key: 'microchip',
        label: 'Microchip Number',
        value: horse.microchipNumber,
      },
      {
        key: 'sex',
        label: 'Sex',
        value: horse.sex,
      },
      {
        key: 'dob',
        label: 'Date of Birth',
        value: horse.dateOfBirth
          ? `${Moment(horse.dateOfBirth).format('ll')} (${calculateHorseAge(horse.dateOfBirth)} years)`
          : null,
      },
      {
        key: 'breed',
        label: 'Breed',
        value: horse.breed,
      },
      {
        key: 'height',
        label: 'Height (hands)',
        value: horse.hands,
      },
      {
        key: 'color',
        label: 'Color',
        value: horse.color,
      },
      {
        key: 'stall',
        label: 'Stall',
        value: horse.stall,
      },
    ];
    return fields;
  }, [horse]);
  const populatedProfileFields = React.useMemo(
    () => profileFields.filter((field) => hasProfileFieldValue(field.value)),
    [profileFields],
  );

  const highlightOrderOptions = React.useMemo(
    () => (horseNoteHighlights || []).map((_, idx) => idx + 1),
    [horseNoteHighlights],
  );
  const sortedHighlights = React.useMemo(
    () => [...(horseNoteHighlights || [])].sort((a, b) => a.highlightOrder - b.highlightOrder),
    [horseNoteHighlights],
  );

  if (isFetchingHorseNoteHighlights) {
    return (
      <Grid container spacing={2}>
        {[...Array(5)].map((_, idx) => (
          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 4,
              lg: 3,
              xl: 2,
            }}
            key={`highlight-skeleton-${idx}`}
          >
            <Skeleton
              sx={{
                borderRadius: 3,
                minHeight: 260,
              }}
              height="100%"
              width="100%"
            />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Box>
      <Paper
        sx={{
          borderRadius: 3,
          p: 2,
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Avatar><Topic /></Avatar>
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Horse Profile Fields
              </Typography>
              <Stack
                direction="row"
                spacing={0.5}
                alignItems="center"
                sx={{ color: 'text.secondary' }}
              >
                <InfoOutlined sx={{ fontSize: 16 }} />
                <Typography variant="caption">
                  Additional profile fields can be managed with Edit Profile.
                </Typography>
              </Stack>
            </Box>
          </Box>
          <Button startIcon={<EditIcon />} size="small" onClick={handleEditProfile}>
            Edit Profile
          </Button>
        </Stack>
        <Grid container spacing={2}>
          {populatedProfileFields.map((field) => (
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: condensed
                  ? 6
                  : 4,
                lg: condensed
                  ? 6
                  : 3,
              }}
              key={field.key}
            >
              <FieldCard {...field} />
            </Grid>
          ))}
        </Grid>
      </Paper>
      <Paper
        sx={{
          borderRadius: 3,
          p: 2,
          mt: 2,
        }}
      >
        <HorseDueDatesComponent barnHorse={currentHorseLodging} isAdmin={isAdmin} zIndex={1500} />
      </Paper>

      <Paper
        sx={{
          borderRadius: 3,
          p: 2,
          mt: 2,
        }}
      >
        <Stack
          direction={{
            xs: 'column',
            sm: 'row',
          }}
          spacing={2}
          alignItems={{
            xs: 'flex-start',
            sm: 'center',
          }}
          justifyContent="space-between"
          mb={2}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Avatar><NoteIcon /></Avatar>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Highlighted Horse Notes
            </Typography>
          </Box>
          {
            condensed
              ? (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    setNoteHighlightAnchorEl(e.currentTarget);
                    setOpenNoteHighlightMenu(true);
                  }}
                >
                  <EditIcon />
                </IconButton>
              )
              : (
                <Button
                  startIcon={<EditIcon />}
                  size="small"
                  onClick={(e) => {
                    setNoteHighlightAnchorEl(e.currentTarget);
                    setOpenNoteHighlightMenu(true);
                  }}
                >
                  Highlight Horse Note
                </Button>
              )
          }
        </Stack>
        {sortedHighlights.length
          ? (
            <Grid container spacing={2}>
              {sortedHighlights.map((note, index) => (
                <Grid
                  size={{
                    xs: 12,
                    md: condensed
                      ? 12
                      : 6,
                    lg: condensed
                      ? 12
                      : 4,
                  }}
                  key={`horse-note-highlight-${note.id}`}
                >
                  <QuestriCard
                    title={note.type}
                    avatar={getIconForNoteType(note.type)}
                    actionReplacement={isAdmin && (
                      <Tooltip placement="top" title="Change Display Order">
                        <Select
                          labelId="highlight-order-select"
                          value={index + 1}
                          size="small"
                          onChange={(e) => handleChangeOrder(note, e.target.value)}
                          input={<OutlinedInput size="small" />}

                        >
                          {highlightOrderOptions.map((option) => (
                            <MenuItem key={`order-item-${option}`} value={option} disabled={option === (index + 1)}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </Tooltip>
                    )}
                  >
                    <Box
                      sx={{
                        pt: 2,
                        pl: 2,
                        pb: 2,
                      }}
                    >
                      <NoteItem
                        isAdmin={isAdmin}
                        note={note}
                        includeHorseInfo={false}
                        hideActions={!isAdmin}
                        includeUserInfo={false}
                        includeTypeChip={false}
                        includeIcons={false}
                        horseId={id}
                        pinnedHorseNoteId={horse.activeNote
                          ? horse.activeNote.id
                          : null}
                        divider={false}
                        onEdit={handleEditClick}
                      />
                    </Box>
                  </QuestriCard>
                </Grid>
              ))}
            </Grid>
          )
          : (
            <Stack direction="row" spacing={2} alignItems="flex-start">
              <Info fontSize="large" color="primary" />
              <Typography variant="body2" color="text.secondary">
                You can show important or highlighted horse notes right on the profile. Create a new note, or select an
                existing one so the most important information is always visible on your horse.
              </Typography>
            </Stack>
          )}
        <Menu
          id="menu-appbar"
          anchorEl={noteHighlightAnchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={!!openNoteHighlightMenu}
          onClose={() => {
            setOpenNoteHighlightMenu(false);
            setNoteHighlightAnchorEl(null);
          }}
        >
          <MenuItem
            onClick={() => {
              openAddEditNoteModal(null);
              setOpenNoteHighlightMenu(false);
              setNoteHighlightAnchorEl(null);
            }}
          >
            <NoteAdd color="secondary" sx={{ mr: 2 }} />
            Create New Note
          </MenuItem>
          <MenuItem onClick={onNotesNavigate}>
            <NoteIcon color="secondary" sx={{ mr: 2 }} />
            Use Existing Note
          </MenuItem>
        </Menu>
      </Paper>
      <Box
        sx={{ mt: 2 }}
      >
        <HorseActivityTimeline
          horseId={id}
          openAddEditNoteModal={openAddEditNoteModal}
          openAddEditBillableModal={openAddEditBillableModal}
          condensed={condensed}
        />
      </Box>
    </Box>
  );
};

HighlightsCardsComponent.propTypes = {
  id: PropTypes.string.isRequired,
  onNotesNavigate: PropTypes.func.isRequired,
  openAddEditNoteModal: PropTypes.func.isRequired,
  openAddEditBillableModal: PropTypes.func.isRequired,
  handleEditProfile: PropTypes.func,
  condensed: PropTypes.bool,
};

HighlightsCardsComponent.defaultProps = {
  handleEditProfile: () => { },
  condensed: false,
}

export default HighlightsCardsComponent;
